<template>
    <nav class="footer-nav">
        <div class="discover-bbe">
            <h4>{{ $t("message.footer.nav_title1") }}</h4>
            <ul>
                <div>
                    <li><a :href="$route('app.individual_banking')">{{ $t("message.navigation.individual") }}</a></li>
                    <li><a :href="$route('app.corporate_banking')">{{ $t("message.navigation.corporate") }}</a></li>
                    <li><a :href="$route('app.financial_institutions')">{{ $t("message.navigation.financial") }}</a></li>
                </div>
                <div>
                    <li><a :href="$route('app.story')">{{ $t("message.navigation.story") }}</a></li>
                    <li><a :href="$route('app.areas')">{{ $t("message.navigation.areas") }}</a></li>
                    <li><a :href="$route('app.governance')">{{ $t("message.navigation.governance") }}</a></li>
                    <!--<li><a :href="$route('app.faqs')">FAQ & Help</a></li>-->
                    <!--<li><a :href="$route('app.search')">Search</a>a/li>-->
                </div>
            </ul>
        </div>
        <div class="resources">
            <h4>{{ $t("message.footer.nav_title2") }}</h4>
            <ul>
                <div>
                    <li><a :href="$route('app.privacy')">{{ $t("message.navigation.privacy") }}</a></li>
                    <li><a :href="$route('app.cookie')">{{ $t("message.navigation.cookie") }}</a></li>
                    <li><a :href="$route('app.complaint')">{{ $t("message.navigation.complaint") }}</a></li>
                </div>
                <div>
                    <li><a :href="$route('app.documents')">{{ $t("message.navigation.legal_doc") }}</a></li>
                    <li><a :href="$route('app.documents')">{{ $t("message.navigation.relations") }}</a></li>
                    <li><a :href="$route('app.contact')">{{ $t("message.navigation.contact") }}</a></li>
                </div>
                <div>
                    <li><a :href="$route('app.career')">{{ $t("message.navigation.career") }}</a></li>
                </div>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: "FooterNav"
}
</script>

<style scoped>

</style>
